module.exports = (__webpack_require__(3))(46);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/ItemModel.js from dll-reference girder_lib
// module id = 24
// module chunks = 0